















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class UtxoLockTime extends Vue {
    @Prop() time!: number

    get isUnlocked(): boolean {
        const now = new Date().getTime() / 1000
        return this.time < now ? true : false
    }

    get date(): Date {
        return new Date(this.time * 1000)
    }
}
